export const DEFAULT_PROJECT_NAME = '新项目';

/**
 * Build the random suffix used by generated Project IDs.
 *
 * @returns {string} Random identifier segment with no separator characters.
 */
function buildProjectRandomPart() {
  const randomUUID = globalThis.crypto?.randomUUID?.();
  if (typeof randomUUID === 'string' && randomUUID.trim()) {
    return randomUUID.replace(/-/g, '').slice(0, 12);
  }
  return Math.random().toString(36).slice(2, 14);
}

/**
 * Generate a client-side Project ID for OBJ-01 Project creation.
 *
 * @returns {string} Project ID prefixed with "project_" and containing timestamp plus random suffix.
 */
export function buildProjectId() {
  return `project_${Date.now()}_${buildProjectRandomPart()}`;
}

export function resolveProjectId(project) {
  return String(project?.project_id || '').trim();
}

const resolveRequestedProjectName = (defaultName, requestedName) => (
  String(requestedName || defaultName || '').trim() || DEFAULT_PROJECT_NAME
);

/**
 * Choose a non-conflicting Project display name for new Project creation.
 *
 * @param {string} defaultProjectName - Preferred Project name from caller configuration.
 * @param {Array<{name?: string}>} projectItems - Existing Project items used to avoid name collisions.
 * @param {string} requestedProjectName - User-entered Project name from the create dialog.
 * @returns {string} Available Project name, with numeric suffix when needed.
 */
export function buildProjectName(defaultProjectName, projectItems = [], requestedProjectName = '') {
  const resolvedDefaultName = resolveRequestedProjectName(defaultProjectName, requestedProjectName);
  const occupiedNames = new Set(
    (Array.isArray(projectItems) ? projectItems : [])
      .map((item) => String(item?.name || '').trim())
      .filter(Boolean),
  );
  if (!occupiedNames.has(resolvedDefaultName)) {
    return resolvedDefaultName;
  }

  let nextIndex = 2;
  while (occupiedNames.has(`${resolvedDefaultName} ${nextIndex}`)) {
    nextIndex += 1;
  }
  return `${resolvedDefaultName} ${nextIndex}`;
}
